import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RoleType } from '@tfagency/core/data-access';
import { Observable } from 'rxjs';
import { RouteConstants } from '../constants/route.constants';
import { CurrentUserService } from '../services/current-user.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private currentUserService: CurrentUserService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userRole = this.currentUserService.getRole();
    if (!(route?.data?.roles as RoleType[]).find((role) => role === userRole)) {
      this.router.navigate([`/${RouteConstants.DASHBOARD_ROUTE}`]);
      return false;
    }
    return true;
  }
}
